import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { faEnvelope } from '@fortawesome/pro-regular-svg-icons';
import { HelprequestService } from './helprequest/helprequest.service';
@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  standalone: false,
  styleUrls: ['./support.component.scss']
})
export class SupportComponent {

  isForm: boolean = false;
  public supportForm: any;

  icons = {
    faEnvelope
  }

  constructor(private _fb: FormBuilder, private router: Router, private helpService: HelprequestService) { }

  ngOnInit() {
    this.supportForm = this._fb.group({
      email: [{ value: sessionStorage.getItem('email'), disabled: true }, [this.customEmailValidator]],
      subject: [''],
      description: [''],
    })
    if(sessionStorage.getItem('fromDashboard')==='true'){
      this.isForm=true;
  }
}

  

   // Custom email validator
    customEmailValidator(control: AbstractControl): ValidationErrors | null {
      const email = control.value;
      if (!email) {
        return null; // Don't validate empty values, let required validator handle that
      }
  
      // More strict email regex pattern
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  
      if (!emailPattern.test(email)) {
        return { invalidEmail: true };
      }
  
      return null;
    }

  onRequestClick(): void {
    this.isForm = true;
  }

  submit() {
    this.supportForm.markAllAsTouched();
    if (this.supportForm.valid) {

      const payload = {
      email: this.supportForm.getRawValue()?.email,
      description: this.supportForm.value.description,
      subject: this.supportForm.value.subject
    };
      this.helpService.helpSubmit(payload).subscribe((res) => {
        this.supportForm.reset();
        if(sessionStorage.getItem('fromDashboard')==='true'){
      sessionStorage.removeItem('fromDashboard');
      this.router.navigate(['/dashboard']);
    }
    else{
        this.isForm = false;
    }
      });
    }
  }

  onBackClick() {
    if(sessionStorage.getItem('fromDashboard')==='true'){
      sessionStorage.removeItem('fromDashboard');
      this.router.navigate(['/dashboard']);
    }
    else{
    this.isForm = false;
    }
  }
}
